<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Bosseln App</v-toolbar-title>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app>
      <v-list-item-group>
        <v-list-item @click="$router.push('/')">Willkommen</v-list-item>
        <v-list-item @click="$router.push('/rules')">Regeln</v-list-item>
        <v-list-item @click="$router.push('/adhoc-game')">Ad-hoc-Spiel</v-list-item>
        <v-list-item @click="$router.push('/league')">Liga erstellen</v-list-item>
        <v-list-item @click="$router.push('/login')">Login</v-list-item>
        <v-list-item @click="$router.push('/register')">Registrierung</v-list-item>
      </v-list-item-group>
    </v-navigation-drawer>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: false,
    };
  }
};
</script>

<style>
@import '~@mdi/font/css/materialdesignicons.css';
@import '~vuetify/dist/vuetify.min.css';
</style>